export default "__VITE_ASSET__X6373OVH__"